import React, { useState } from 'react'; 
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Menu,
  MenuItem,
  Paper,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const TaskFunnel = ({ options, statuses }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [timeRangeLabel, setTimeRangeLabel] = useState('All'); // Default label
  const [timeRangeValue, setTimeRangeValue] = useState('all'); // Internal value for navigation

  const handleClick = (statusValue) => {
    navigate(`/tasks?status=${statusValue}&range=${timeRangeValue}`);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleTimeRangeSelect = (range) => {
    setTimeRangeLabel(range.label);
    setTimeRangeValue(range.value);
    handleMenuClose();
  };

  // Create mapping from value to label
  const valueToLabelMap = options.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
  }, {});

  // Handle undefined or empty statuses
  if (!statuses || Object.keys(statuses).length === 0) {
    return (
      <Box sx={{ width: 280, mx: 'auto', mt: 3, textAlign: 'center' }}>
        <Typography variant="h6">Loading task statuses...</Typography>
      </Box>
    );
  }

  // Get statuses for selected time range using mapped label
  const currentStatuses = statuses[valueToLabelMap[timeRangeValue]] || {};

  const statusColors = {
    unhandled: '#f44336',
    inprogress: '#2196f3',
    completed: '#4caf50',
    overdue: '#ff9800',
  };

  const clipPaths = [
    'polygon(0 0, 100% 0, 90% 100%, 10% 100%)',
    'polygon(10% 0, 90% 0, 90% 100%, 10% 100%)',
    'polygon(15% 0, 85% 0, 85% 100%, 15% 100%)',
    'polygon(20% 0, 80% 0, 100% 100%, 0% 100%)',
  ];

  return (
    <Box sx={{ width: 280, mx: 'auto', mt: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center', mb: 2 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Task Status
        </Typography>

        <Button
          variant="outlined"
          size="small"
          endIcon={<ArrowDropDownIcon />}
          onClick={handleMenuClick}
        >
          {timeRangeLabel}
        </Button>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
          {options.map((range) => (
            <MenuItem
              key={range.value}
              onClick={() => handleTimeRangeSelect(range)}
              selected={range.value === timeRangeValue}
            >
              {range.label}
            </MenuItem>
          ))}
        </Menu>
      </Box>

      {Object.entries(currentStatuses).map(([key, count], index) => (
        <Paper
          key={key}
          onClick={() => handleClick(key)}
          sx={{
            bgcolor: statusColors[key] || '#9e9e9e',
            color: '#fff',
            cursor: 'pointer',
            clipPath: clipPaths[index % clipPaths.length],
            py: 1.5,
            px: 1,
            textAlign: 'center',
            mb: 0.5,
            fontWeight: 'bold',
            transition: 'transform 0.2s',
            '&:hover': {
              transform: 'scale(1.03)',
            },
          }}
        >
          {key.charAt(0).toUpperCase() + key.slice(1)}: {count}
        </Paper>
      ))}
    </Box>
  );
};

export default TaskFunnel;
